export default __webpack_public_path__ + "static/media/Snapshot.3b807ce8.png";